module.exports = __webpack_public_path__ + "assets/img/Affiches_007.cd6a4712.jpg";